import { flatten } from 'lodash';

import { QayaqScheduleRoute, QayaqScheduleRouteSegment } from '@/lib/api/providers/qayaq/types';
import { CANAL_TRANSIT, MODE_TRANSFER, TRANSFER_STOP } from '@/lib/constants';
import { processViaLocationIds } from '@/lib/transformers/option/utils/get-api-option-via';

export const extractSegments = (route: QayaqScheduleRoute): QayaqScheduleRouteSegment[] => {
  const segments = route.sequences.map((sequence) => sequence.segments);
  return flatten(segments);
};

export const getSegmentTransferCount = (segments: QayaqScheduleRouteSegment[]): number => {
  const transfers = segments.filter(
    (s) => s.type === MODE_TRANSFER && s.transferType !== TRANSFER_STOP && s.transferType !== CANAL_TRANSIT,
  );
  return transfers.length;
};

export const getSegmentStopCount = (segments: QayaqScheduleRouteSegment[]): number => {
  const transfers = segments.filter((s) => s.type === MODE_TRANSFER && s.transferType === TRANSFER_STOP);
  const segmentStops = segments.reduce((acc, segment) => (segment.stops?.length || 0) + acc, 0);
  return transfers.length + segmentStops;
};

export const getRouteViaLocations = (routeSegments: QayaqScheduleRouteSegment[]) => {
  const waypoints = flatten(routeSegments.map((segment) => segment.waypoints || []));
  const waypointIds = waypoints.map((location) => `locode ${location.value}`);
  return processViaLocationIds(waypointIds);
};
